
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Catalogo from "../pages/catalogo/page";
import Modelos from "../pages/modelos/page";
import Importacao from "../pages/importacao/page";
import Suporte from "../pages/suporte/page";
import Contato from "../pages/contato/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/catalogo",
    element: <Catalogo />,
  },
  // {
  //   path: "/modelos",
  //   element: <Modelos />,
  // },
  {
    path: "/importacao",
    element: <Importacao />,
  },
  {
    path: "/suporte",
    element: <Suporte />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
